const header = require('./includes/header');
const backgroundAnimation = require('./includes/background-animation');
const leftMenu = require('./includes/left-menu');
const customScroll = require('./includes/custom-scroll');
const homepage = require('./pages/homepage')
const aboutUs = require('./pages/about-us')
const services = require('./pages/services');
const industries = require('./pages/industries')
const news = require('./pages/news');
$("document").ready(function () {
    header();
    backgroundAnimation();
    leftMenu();
    customScroll();
    homepage();
    aboutUs();
    services();
    industries();
    news();
})

$(window).resize(function () {
    //headerMenu()
})
